export const REMEDY_PRICE = 9.15;

export const PRIORITY_STATUS_COLORS = {
  'P1': 'red',
  'P2': 'amber',
  'P3.1': 'red',
  'P3.2': 'amber',
  'P3.3': 'yellow',
  'P4.1': 'red',
  'P4.2': 'amber',
  'P4.3': 'yellow',
  'P5': 'amber'
};

export const ONE_YEAR_IN_S = 60 * 60 * 24 * 365;
export const CONTRACT_START_DATE = {
  DESC: 'desc',
  ASC: 'asc'
}

export const BRANCH_TIMEZONES = [
  'Europe/London',
  'America/Vancouver',
  'America/Creston',
  'America/Edmonton',
  'America/Regina',
  'America/Winnipeg',
  'America/Atikokan',
  'America/Toronto',
  'America/Halifax',
  'America/St_Johns',
];
